import { Link } from "react-router-dom";
import { Calculator, ArrowRight, ShieldCheck } from "lucide-react";
import { TOOLS, COLOR } from "../lib/tools";
import { useToolsT } from "../lib/toolsI18n";
import { Seo, SITE } from "../lib/seo";

export default function ToolsPage() {
  const { tt, reg } = useToolsT();
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid="tools-page">
      <Seo
        title="Free Health Calculators — BMI, A1C, Blood Pressure & More | AskMyDoctor AI"
        description="12+ free, private health calculators: BMI, A1C, blood pressure, eGFR, cholesterol, pediatric fever dosing and more. Calculated in your browser, nothing stored."
        path="/tools"
        image={`${SITE}/og-tools.jpg`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "Free Health Calculators",
          url: `${SITE}/tools`,
          hasPart: TOOLS.map((tool) => ({
            "@type": "SoftwareApplication",
            name: reg(tool.slug).t,
            applicationCategory: "HealthApplication",
            operatingSystem: "Web",
            url: `${SITE}/tools/${tool.slug}`,
            offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
          })),
        }}
      />
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 bg-teal-100 text-teal-800 font-bold text-sm px-3 py-1 rounded-full mb-4">
          <Calculator className="w-4 h-4" /> {tt("badge")}
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight">{tt("h1")}</h1>
        <p className="text-lg text-slate-600 mt-4">{tt("sub")}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
        {TOOLS.map((tool) => {
          const c = COLOR[tool.color];
          const Icon = tool.icon;
          const meta = reg(tool.slug);
          return (
            <Link key={tool.slug} to={`/tools/${tool.slug}`} data-testid={`tool-card-${tool.slug}`}
              className={`group relative overflow-hidden rounded-2xl border-2 ${c.ring} bg-white p-6 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200`}>
              <div className={`inline-grid place-items-center w-12 h-12 rounded-xl bg-gradient-to-br ${c.grad} text-white shadow-sm mb-4`}>
                <Icon className="w-6 h-6" />
              </div>
              <span className={`inline-block text-xs font-bold px-2 py-0.5 rounded-full mb-2 ${c.chip}`}>{meta.s}</span>
              <h2 className="font-heading font-bold text-lg text-slate-900">{meta.t}</h2>
              <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{meta.d}</p>
              <span className={`inline-flex items-center gap-1 text-sm font-bold mt-4 ${c.icon}`}>
                {tt("open")} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          );
        })}
      </div>

      <div className="mt-10 flex items-start gap-3 rounded-2xl border-2 border-slate-200 bg-slate-50 p-5" data-testid="tools-disclaimer">
        <ShieldCheck className="w-6 h-6 text-teal-600 flex-shrink-0 mt-0.5" />
        <p className="text-sm text-slate-600 leading-relaxed">{tt("disclaimer")}</p>
      </div>
    </div>
  );
}
